(() => {
  if (window.__clarityHeaderLoaded) return;
  window.__clarityHeaderLoaded = true;

  // Inline delete icon once so we can reuse in JS-rendered cart items
  const getDeleteIcon = () => {
    if (window.__deleteIcon) return window.__deleteIcon;
    const tpl = document.querySelector('template[data-delete-icon]');
    let svgEl = null;
    if (tpl && tpl.content) {
      svgEl = tpl.content.querySelector('svg');
    }
    if (!svgEl) {
      svgEl = document.querySelector('template[data-delete-icon] svg, .cd-remove svg');
    }
    const fallback = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm2.72 11.78-2.22-2.22-2.22 2.22a.75.75 0 0 1-1.06-1.06l2.22-2.22-2.22-2.22a.75.75 0 0 1 1.06-1.06l2.22 2.22 2.22-2.22a.75.75 0 0 1 1.06 1.06L11.56 10l2.22 2.22a.75.75 0 0 1-1.06 1.06Z" fill="currentColor"/></svg>';
    window.__deleteIcon = svgEl ? svgEl.outerHTML : fallback;
    return window.__deleteIcon;
  };
  const deleteIconHtml = getDeleteIcon();

  const navDrawer = () => document.getElementById('nav-drawer');
  const headerHamburger = () => document.querySelector('.header__hamburger');
  const cartDrawer = () => document.getElementById('cart-drawer');
  const cartOverlay = () => document.getElementById('cart-overlay');

  const openNav = () => {
    const drawer = navDrawer();
    if (!drawer || drawer.open) return;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    const hb = headerHamburger();
    if (hb) hb.setAttribute('aria-expanded', 'true');
  };

  const closeNav = () => {
    const drawer = navDrawer();
    if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    const hb = headerHamburger();
    if (hb) hb.setAttribute('aria-expanded', 'false');
    const done = (evt) => {
      if (evt && evt.target !== drawer) return;
      drawer.removeEventListener('transitionend', done);
      drawer.classList.remove('is-closing');
      drawer.close();
    };
    drawer.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 450);
  };

  const formatMoney = (cents) => {
    const value = (cents || 0) / 100;
    try {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined;
      return new Intl.NumberFormat(undefined, currency ? { style: 'currency', currency } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    } catch (_) {
      return value.toFixed(2);
    }
  };

  const updateCartBubble = (count) => {
    const bubble = document.querySelector('.header__cart-bubble');
    if (!bubble) return;
    const n = Number(count) || 0;
    bubble.textContent = n;
    bubble.hidden = n <= 0;
    bubble.setAttribute('aria-hidden', n <= 0 ? 'true' : 'false');
  };

  const renderCart = (cart) => {
    const drawer = cartDrawer();
    const content = drawer && drawer.querySelector('#cd-content');
    if (!drawer || !content) return;
    if (!cart || !cart.items || cart.items.length === 0) {
      content.innerHTML = '<div class="cd-empty">Your cart is empty.</div>';
      const sub = drawer.querySelector('.cd-sub-val');
      if (sub) sub.textContent = formatMoney(0);
      return;
    }
    const itemsHtml = cart.items.map((item, idx) => {
      const bundle = item.properties && item.properties['Bundle'] ? `<div class="cd-sub"><strong>Bundle:</strong> ${item.properties['Bundle']}</div>` : '';
      const vendor = item.vendor ? `<div class="cd-vendor">${item.vendor}</div>` : '';
      const imgSrc = item.image ? `${item.image}?width=240` : '';
      return `<li class="cd-item" data-line="${idx + 1}">
        <a class="cd-thumb" href="${item.url}">${imgSrc ? `<img class=\"cd-img\" alt=\"${item.product_title}\" src=\"${imgSrc}\" loading=\"lazy\"/>` : ''}</a>
        <div class="cd-info">
          <a class="cd-name" href="${item.url}">${item.product_title}</a>
          ${bundle}${vendor}
          <div class="cd-row">
            <div class="cd-qty-wrap">
              <div class="cd-qty">
                <button class="cd-qty-btn" data-action="decrease" aria-label="Decrease">-</button>
                <span class="cd-qty-val" aria-live="polite">${item.quantity}</span>
                <button class="cd-qty-btn" data-action="increase" aria-label="Increase">+</button>
              </div>
              <button class="cd-remove" type="button" data-remove="${idx + 1}" aria-label="Remove item">${deleteIconHtml}</button>
            </div>
            <div class="cd-price">${formatMoney(item.final_line_price)}</div>
          </div>
        </div>
      </li>`;
    }).join('');
    content.innerHTML = `<ul class="cd-items" role="list">${itemsHtml}</ul>`;
    const subtotalEl = drawer.querySelector('.cd-sub-val');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateCartBubble(cart.item_count);
  };

  const refreshCart = async () => {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      updateCartBubble(cart.item_count);
    } catch (_) {}
    if (!navigator.onLine) updateCartBubble(0);
  };

  const changeLine = async (line, quantity) => {
    const drawer = cartDrawer();
    const lines = drawer ? Array.from(drawer.querySelectorAll('.cd-item')) : [];
    const target = lines.find((el) => parseInt(el.getAttribute('data-line'), 10) === line);
    if (target) target.classList.add('is-loading');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (_) {} finally {
      if (target) target.classList.remove('is-loading');
    }
  };

  const openCart = () => {
    const drawer = cartDrawer();
    const overlay = cartOverlay();
    if (!drawer || drawer.open) return;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    if (overlay) overlay.classList.add('is-open');
    refreshCart();
  };

  const closeCart = () => {
    const drawer = cartDrawer();
    const overlay = cartOverlay();
    if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    const done = (evt) => {
      if (evt && evt.target !== drawer) return;
      drawer.removeEventListener('transitionend', done);
      drawer.classList.remove('is-closing');
      drawer.close();
    };
    drawer.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 450);
    if (overlay) overlay.classList.remove('is-open');
  };

  const bindDialogEvents = () => {
    const nav = navDrawer();
    if (nav && !nav.dataset.headerBound) {
      nav.addEventListener('cancel', (e) => { e.preventDefault(); closeNav(); });
      nav.addEventListener('close', () => {
        nav.classList.remove('is-open', 'is-closing');
        const hb = headerHamburger();
        if (hb) hb.setAttribute('aria-expanded', 'false');
      });
      nav.dataset.headerBound = '1';
    }
    const cart = cartDrawer();
    if (cart && !cart.dataset.headerBound) {
      cart.addEventListener('cancel', (e) => { e.preventDefault(); closeCart(); });
      cart.dataset.headerBound = '1';
    }
  };

  document.addEventListener('click', (e) => {
    const cartTrigger = e.target.closest('[data-cart-open]');
    if (cartTrigger) {
      e.preventDefault();
      openCart();
      return;
    }
    const navTrigger = e.target.closest('.header__hamburger');
    if (navTrigger) {
      e.preventDefault();
      openNav();
      return;
    }
    const navClose = e.target.closest('.nav-drawer__close');
    if (navClose) {
      e.preventDefault();
      closeNav();
      return;
    }
    const nav = navDrawer();
    if (nav && e.target === nav) {
      closeNav();
      return;
    }

    const drawer = cartDrawer();
    if (drawer) {
      if (e.target === drawer) {
        closeCart();
        return;
      }
      const qtyBtn = e.target.closest('.cd-qty-btn');
      if (qtyBtn && drawer.contains(qtyBtn)) {
        e.preventDefault();
        e.stopPropagation();
        const itemEl = qtyBtn.closest('.cd-item');
        if (itemEl) {
          const line = parseInt(itemEl.getAttribute('data-line'), 10);
          const qtyEl = itemEl.querySelector('.cd-qty-val');
          const controls = itemEl.querySelectorAll('.cd-qty-btn');
          const current = parseInt(qtyEl && qtyEl.textContent, 10) || 1;
          const next = qtyBtn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
          if (qtyEl) qtyEl.textContent = String(next);
          controls.forEach((btn) => { btn.disabled = true; });
          changeLine(line, next).finally(() => controls.forEach((btn) => { btn.disabled = false; }));
        }
        return;
      }
      const removeBtn = e.target.closest('.cd-remove');
      if (removeBtn && drawer.contains(removeBtn)) {
        e.preventDefault();
        const line = parseInt(removeBtn.getAttribute('data-remove'), 10);
        if (line > 0) changeLine(line, 0);
        return;
      }
      const closeBtn = e.target.closest('.cd-close');
      if (closeBtn && drawer.contains(closeBtn)) {
        e.preventDefault();
        closeCart();
        return;
      }
      if (e.target.classList && e.target.classList.contains('cd-backdrop')) {
        closeCart();
        return;
      }
    }
    const overlay = cartOverlay();
    if (overlay && e.target === overlay) {
      e.preventDefault();
      closeCart();
    }
  });

  window.cartOpen = openCart;
  bindDialogEvents();

  document.addEventListener('shopify:section:load', bindDialogEvents);
  refreshCart();
})();
